import Papa from 'papaparse'

export const TOPUPS_COLUMNS = [
  'Id',
  'PayerId',
  'MerchantTopupId',
  'CurrencyFrom',
  'AmountFrom',
  'FactAmountFrom',
  'CurrencyTo',
  'AmountTo',
  'FactAmountTo',
  'TotalCommissionPercent',
  'TotalCommissionAmount',
  'ExchangeRateFromTo',
  'ConfirmedAt',
  'CreatedAt',
  'MethodFrom',
] as const

export const WITHDRAWALS_COLUMNS = [
  'Id',
  'CurrencyFrom',
  'AmountFrom',
  'CurrencyTo',
  'AmountTo',
  'FactAmountTo',
  'TotalCommissionAmount',
  'ExchangeRateFromTo',
  'ConfirmedByTraderAt',
  'MerchantWithdrawId',
  'CreatedAt',
  'MethodToName',
  'MerchantCommissionPercent'
] as const

/** Соответствие: тип экспорта → набор колонок. Если типа нет — CSV отдаём как есть. */
export const COLUMNS_BY_EXPORT_TYPE: Partial<Record<string, readonly string[]>> = {
  topups: TOPUPS_COLUMNS,
  withdrawals: WITHDRAWALS_COLUMNS,
}

type Row = Record<string, string>

function parseCsv(text: string): Row[] {
  const { data } = Papa.parse<Row>(text, {
    header: true,
    skipEmptyLines: 'greedy',
    delimiter: ';',
  })
  return data.filter((row) => Object.values(row).some((v) => v != null && String(v).trim() !== ''))
}

function pickColumns(rows: Row[], columns: readonly string[]): Row[] {
  return rows.map((row) => {
    const out: Row = {}
    for (const col of columns) out[col] = row[col] ?? ''
    return out
  })
}

function buildCsv(rows: Row[], columns: readonly string[]): string {
  const csv = Papa.unparse(
    {
      fields: [...columns],
      data: rows.map((r) => columns.map((c) => r[c])),
    },
    { delimiter: ';' }
  )
  // BOM — чтобы Excel корректно открыл кириллицу
  return '\uFEFF' + csv
}

/**
 * Оставляет в CSV только нужные колонки для конкретного типа экспорта.
 * Если для типа набор колонок не задан — возвращает исходный текст без изменений.
 */
export function normalizeCsvByExportType(csvText: string, exportType: string): string {
  const columns = COLUMNS_BY_EXPORT_TYPE[exportType]
  if (!columns) return csvText // прочие типы — как есть, байт-в-байт

  // убираем BOM перед парсингом, если он есть
  const clean = csvText.charCodeAt(0) === 0xfeff ? csvText.slice(1) : csvText
  const rows = parseCsv(clean)
  const picked = pickColumns(rows, columns)
  return buildCsv(picked, columns)
}
